import React, { Dispatch, SetStateAction, useMemo } from 'react';

import { Select } from '@components/common';

import { IVendor } from '@interfaces/cmModule/dto/cmModuleDTO';
import { TSelectOptionType } from '@components/common/Select/Select.types';

import { TVendorsValues } from '@enums/common';

import styles from './Vendor.module.scss';

const VENDOR_WIDTH = '250px';

interface IVendorProps {
	vendor: string;
	setVendor: Dispatch<SetStateAction<string>>;
	optionsVendorsKpi: Array<TSelectOptionType & { isDefault: boolean }>;
	setDefaultKpiVendor: (data: IVendor) => void;
}

const Vendor = (props: IVendorProps) => {
	const { vendor, setVendor, optionsVendorsKpi, setDefaultKpiVendor } = props;

	const onChangeVendor = (option: TSelectOptionType<string>) => {
		if (option?.value) {
			setVendor(option.value);
		}
	};

	const setFavorite = (data: TSelectOptionType) => {
		if (data?.isDefault) {
			return;
		}

		setDefaultKpiVendor({ vendor: data?.value as TVendorsValues } as never);
	};

	const valueVendor = useMemo(() => {
		return optionsVendorsKpi.find((option) => option.value === vendor);
	}, [vendor, optionsVendorsKpi]);

	return (
		<div className={styles.vendorWrapper}>
			<div className={styles.title}>
				Vendor
			</div>
			<Select
				favoriteTooltip='Set vendor as default'
				handleChange={onChangeVendor}
				isFavorite
				isWithoutUseForms
				name='vendor'
				options={optionsVendorsKpi}
				placeholder='Select vendor'
				required
				setFavorite={setFavorite}
				value={valueVendor}
				width={VENDOR_WIDTH}
			/>
		</div>
	);
};

export default Vendor;
